<template>
    <div name="infra" class="infra">
        <div class="infra-inner">
            <img
                class="infra-back-image"
                src="../../assets/partners_pc/bg_infra.png"
                alt="현재 무제한 무료 프로모션 진행중"
            />
            <div class="title-area">
                <span class="title">현재 무제한 무료 프로모션 진행중</span>
                <span class="sub-text"
                    >추가 금액 없이 누리는 모든 기능, 지금 바로 만나보세요</span
                >
            </div>
            <a
                href="https://partner.soldoc.co.kr/"
                target="_blank"
                title="새창으로 열림"
                class="btn-infra"
                >무료 가입하기</a
            >
        </div>
    </div>
</template>

<script>
export default {
    name: "infra",
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".infra-inner").offset().top;
            var aniText = $(".infra-inner .title-area");
            var aniItem = $(".infra-inner .btn-infra");

            if (height <= innerTop - 800) {
                $(aniText).css("display", `none`);
                $(aniItem).css("display", `none`);
            } else if (height > innerTop - 800 && height < innerTop + 1500) {
                $(aniText).css("display", `flex`);
                $(aniItem).css("display", `flex`);
            } else if (height > innerTop + 1800) {
                // $(aniText).css("display", `none`);
                // $(aniItem).css("display", `none`);
            }
        });
    },
    methods: {},
};
</script>

<style scoped>
.infra {
    width: 100%;
    height: 436px;
    background: #3a4149;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
}
.infra-inner {
    width: 100%;
    height: 486px;
    background: linear-gradient(180deg, #008def 17.28%, #314ac3 100%);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    flex-direction: column;
    padding-top: 112px;
}
.infra-inner .title-area {
    display: none;
    flex-direction: column;
    animation: fadeInUp1 2s;
}
.infra-inner .title {
    font-size: 44px;
    font-weight: 600;
    line-height: 68px;
    text-align: center;
    color: #fff;
    z-index: 1;
}
.infra-inner .sub-text {
    margin-top: 11px;
    font-size: 22px;
    font-weight: 400;
    line-height: 30px;
    color: #fff;
    text-align: center;
    z-index: 1;
}
.infra-back-image {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
}
.infra-inner .btn-infra {
    display: none;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 48px;
    padding: 7px 15px;
    border-radius: 4px;
    border: 1px solid #008def;
    background: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 34px;
    color: #008def;
    margin-top: 46px;
    z-index: 2;
    animation: fadeInUp1 2s;
}
.infra-inner .btn-infra:hover {
    background: #008def;
    color: #fff;
    text-decoration: none;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_partners/InfraContact.vue